//report url test
// export const REPORT_URL = 'http://ec2-52-34-102-149.us-west-2.compute.amazonaws.com:9999';
// export const REPORT_API_URL = 'http://ec2-52-34-102-149.us-west-2.compute.amazonaws.com:9999/api';

//report url dev
// export const REPORT_URL = 'http://ec2-34-216-165-102.us-west-2.compute.amazonaws.com:9999';
// export const REPORT_API_URL = 'http://ec2-34-216-165-102.us-west-2.compute.amazonaws.com:9999/api';

export const REPORT_URL = process.env.REACT_APP_REPORT_URL;
export const REPORT_API_URL = process.env.REACT_APP_REPORT_API_URL;
console.log(window.profile, "window.profile");
export const CURRENT_SITE_URI = window.profile.currentSiteUri;
export const SITE_ONE_SERVICE_URI = window.profile.siteOneServiceUri;
export const REDIRECT_URL_INVITE = `${CURRENT_SITE_URI}/account/active-user`;
export const REDIRECT_URL_EMAIL_CONFIRM = `${CURRENT_SITE_URI}/account/confirm-email`;
export const REDIRECT_RESET_PASSWORD = `${CURRENT_SITE_URI}/account/reset-password`;
export const REDIRECT_INVITE_BUILDER = `${CURRENT_SITE_URI}/client/term-of-service`;
export const REDIRECT_INVITE_SUBCONTRACTOR = "/account/active-user";
export const ACCESS_TOKEN_SCHEME = window.profile.accessTokenScheme;
export const GLOBAL_API_URL = window.profile.globalApiUrl;
export const REGION_AND_MARKET = window.profile.regionAndMarket;
export const COMPANY_NAME = window.profile.CompanyName;
export const ROLES = window.profile.roles;
export const CLIENT_ID = window.profile.clientId;

export const USER_STATUS = {
  PENDING: 0,
  ACTIVE: 1,
  SUSPENDED: 2,
  LOCKED: 3,
};

export const CLIENT_STATUS = {
  PENDING: 0,
  ACTIVE: 1,
  SUSPENDED: 2,
};

export const CLIENT_TYPE = {
  System: 0,
  Builder: 1,
  Subcontractor: 2,
};

export const LOCKED_TYPE = {
  RESET_PASSWORD: 0,
  CHANGE_EMAIL: 1,
};

export const LIST_ROLES = [
  { key: "SystemAdministrator", value: "Administrator" },
  { key: "SystemPowerUser", value: "Power user" },
  { key: "SystemAgent", value: "Agent" },
  { key: "BuilderSuperAdmin", value: "Super admin" },
  { key: "BuilderAdmin", value: "Admin" },
  { key: "BuilderUser", value: "User" },
];

export const SYSTEM_ADMINISTRATOR = "SystemAdministrator";
export const SYSTEM_POWER_USER = "SystemPowerUser";
export const SYSTEM_AGENT = "SystemAgent";

/*export const ROLES = [
  { key: 'SystemAdministrator', value: 'System Administrator' },
  { key: 'SystemPowerUser', value: 'System Power User' },
  { key: 'SystemAgent', value: 'System Agent' }
  /*  {key: 'BuilderSuperAdmin', value: 'Super admin'},
  {key: 'SystemAdministrator', value: 'Administrator'},
  {key: 'BuilderUser', value: 'User'}*/
//];

export const USER_STATUS_VALUE = [
  { key: 0, value: "Invited" },
  { key: 1, value: "Active" },
  { key: 2, value: "Suspended" },
  { key: 3, value: "Locked" },
];

export const CLIENT_STATUS_VALUE = [
  { key: 0, value: "Pending" },
  { key: 1, value: "Active" },
  { key: 2, value: "Suspended" },
];

export const CLIENT_TYPE_VALUE = [
  { key: 0, value: "System" },
  { key: 1, value: "Builder" },
  { key: 2, value: "Subcontractor" },
];

export const PUNCH_ITEM_STATUS_VALUE = [
  { key: 1, value: "Open" },
  { key: 2, value: "Pending" },
  { key: 4, value: "Resolved" },
  { key: 5, value: "Closed" },
  { key: 6, value: "Requested to reopen" },
];

export const WO_STATUS_VALUE = [
  { key: 0, value: "Awaiting review" },
  { key: 1, value: "Open" },
  { key: 2, value: "Pending" },
  { key: 3, value: "Declined" },
  { key: 4, value: "Resolved" },
  { key: 5, value: "Closed" },
  { key: 6, value: "Requested to reopen" },
  { key: 7, value: "Scheduled" },
];

export const DISPLAY_NAME = window.profile.DisplayName;
export const CURRENT_USER_ID = window.profile.CurrentUserId;
export const DEFAULT_ROLES = "SystemAdministrator";
export const DEFAULT_ROLES_SYSTEM = "SystemAdministrator";
export const DEFAULT_AVATAR = window.profile.DefaultAvatar
  ? window.profile.DefaultAvatar
  : "/images/default_avatar.svg";
export const LOGO_30 = window.profile.logoUrl
  ? `${window.profile.logoUrl}`
  : "/images/logo_30.png";
export const HO_LOGO = window.profile.hoLogoUrl
  ? `${window.profile.hoLogoUrl}`
  : null;
export const NO_PICTURE = "/images/no-picture.png";
export const S1_TOKEN = window.profile.clientName
  ? `${window.profile.clientName.replace(" ", "_")}_token`
  : "s1_token";
export const S1_UID = window.profile.clientName
  ? `${window.profile.clientName.replace(" ", "_")}_uid`
  : "s1_uid";
export const S1_REFRESH_TOKEN = window.profile.clientName
  ? `${window.profile.clientName.replace(" ", "_")}_refresh_token`
  : "s1_refresh_token";
export const S1_EXPIRES_TIME = window.profile.clientName
  ? `${window.profile.clientName.replace(" ", "_")}_expires`
  : "s1_expires";
export const S1_TOKEN_CREATED = window.profile.clientName
  ? `${window.profile.clientName.replace(" ", "_")}_token_created`
  : "s1_token_created";
export const S1_ROLE_NAME = window.profile.clientName
  ? `${window.profile.clientName.replace(" ", "_")}_role_name`
  : "s1_role_name";
export const S1_REDIRECT_CLIENT_URL = "S1_REDIRECT_CLIENT_URL";
export const IS_SSO_USER = "IS_SSO_USER";
export const S1_REDIRECT_CLIENT_LOGIN_URL = "S1_REDIRECT_CLIENT_LOGIN_URL";
export const APPLY_BRANDING_FOR_HOMEOWNERS =
  window.profile.applyBrandingForHomeowners;



// WEBPACK FOOTER //
// ./src/config/variables.system.js